import {useTranslation} from 'react-i18next';
import React, {useMemo} from 'react';
import {IMatchPairsReport} from '../../../../../analytics';
import './confusionMatrix.scss';
import {useHoverState} from './hooks';
import ConfusionMatrixHeader from './ConfusionMatrixHeader';
import ConfusionMatrixRow from './ConfusionMatrixRow';

interface ConfusionMatrixProps {
    matchPairReport: IMatchPairsReport;
    showPercentages?: boolean;
}

function ConfusionMatrix({matchPairReport, showPercentages = false}: ConfusionMatrixProps): JSX.Element {
    const {t} = useTranslation();
    const {hoveredRow, hoveredCol, handleCellHover, handleMouseLeave} = useHoverState();

    const matrixData = useMemo(() => {
        const {leftLabels = [], rightLabels = [], labelMatrix, totals = {}} = matchPairReport || {};
        return {leftLabels, rightLabels, labelMatrix, totals};
    }, [matchPairReport]);

    const {leftLabels, rightLabels, labelMatrix, totals} = matrixData;

    if (!labelMatrix || leftLabels.length === 0 || rightLabels.length === 0) {
        return <div className="c-confusionMatrix">{t('reportPage.noData')}</div>;
    }

    return (
        <div className="c-confusionMatrix" onMouseLeave={handleMouseLeave}>
            <ConfusionMatrixHeader rightLabels={rightLabels} />

            {leftLabels.map((leftLabel, rowIndex) => (
                <ConfusionMatrixRow
                    key={leftLabel}
                    leftLabel={leftLabel}
                    rightLabels={rightLabels}
                    labelMatrix={labelMatrix}
                    totals={totals}
                    showPercentages={showPercentages}
                    rowIndex={rowIndex}
                    isRowHighlighted={hoveredRow === rowIndex}
                    hoveredCol={hoveredCol}
                    onCellHover={handleCellHover}
                />
            ))}
        </div>
    );
}

export default ConfusionMatrix;
